export const WARN_AFTER_MS = 10 * 60_000;

export function formatClock(iso: string | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' });
}

/** "11.06.2026 14:05" — matches the design's "Ordered:" line. */
export function formatOrderedAt(iso: string | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  return `${dd}.${mm}.${date.getFullYear()} ${formatClock(iso)}`;
}

export function isWarnAge(createdUtc: string | undefined, nowMs: number): boolean {
  if (!createdUtc) return false;
  const created = new Date(createdUtc).getTime();
  if (Number.isNaN(created)) return false;
  return nowMs - created >= WARN_AFTER_MS;
}
